// extracted by mini-css-extract-plugin
export var typingIndicator = "_p5-0";